export const START   = 'START ';
export const UPDATE_PERSONAL_FORM = 'UPDATE_PERSONAL_FORM';
export const UPDATE_FORM = 'UPDATE_FORM';
export const SET_PRIOR_TREATMENT = 'SET_PRIOR_TREATMENT';
export const SET_SUICIDE_ATTEMPT = 'SET_SUICIDE_ATTEMPT';
export const SET_SUICIDE_ATTEMPT_WHEN = 'SET_SUICIDE_ATTEMPT_WHEN';
export const RESET = 'RESET';
export const CHECK_ONBORDING = 'CHECK_ONBORDING';